// Application constants
export const APPLICATION_CONTAINER_ID = 'AppContainer';

export const DEFAULT_LAYOUT = 'main'; // default handlebars layout template
export const DEFAULT_THEME = "dark";

// Path constants
export const PATH_HOME = '/';
export const PATH_FORM_INDEX = '/forms';

export const PATH_THANKS = '/thanks';
export const PATH_REGISTERED = '/registered';

export const PATH_CONTACTUS = '/contact-us';
export const PATH_PREFERENCECENTRE = '/preference-centre';
export const PATH_REQUEST_TESTDRIVE = '/request-a-test-drive';
export const PATH_REQUEST_QUOTE = '/request-quote';
export const PATH_ADE_RYI = '/register-experience-interest';
export const PATH_ADE_BROCHURE = '/request-experience-brochure';
export const PATH_ADE_WAITLIST = '/ade-waitlist';
export const PATH_UPCOMINGMODELS = '/upcoming-models';
export const PATH_UPCOMINGMODEL = '/upcoming-model';
export const PATH_UPCOMINGMODEL_DEALER = '/dealer-contact';
export const PATH_PRICECALCULATOR = '/price-calculator';
export const PATH_STARTPRICECALCULATOR = '/starting-price-calculator';
export const PATH_FINANCE_PRICE_CALCULATOR = '/finance-price-calculator';
export const PATH_FINANCE_BUDGET_CALCULATOR = '/finance-budget-calculator';
export const PATH_SERVICE_PLAN_CALCULATOR = '/service-pricing-calculator';
export const PATH_SERVICE_PRICE = '/service-price';
export const PATH_XTIME = '/book-a-service';
export const PATH_XTIME_DEALER = '/dealer-book-a-service';
export const PATH_AFS_FEEDBACK = '/afs-feedback';
export const PATH_AFS_ENQUIRY = '/afs-enquiry';
export const PATH_AFS_FLEET_ENQUIRY = '/afs-fleet-enquiry';
export const PATH_AFS_CALCULATOR = '/afs-calculator';
export const PATH_CHANGE_VEHICLE_OWNER = '/change-vehicle-ownership';
export const PATH_DEALER_OFFER = '/dealer-offer-enquiry';
export const PATH_F1_ENQUIRY = '/f1-enquiry';
export const PATH_RECALL_TAKATA = '/takata-recall';
export const PATH_LOCATEADEALER = '/locate-a-dealer';
export const PATH_LOCATEAREPAIRCENTRE = '/locate-a-repair-centre';
export const PATH_LOCATETRADEPART = '/locate-a-trade-parts-centre';
export const PATH_BUY_SERVICE_PLAN = '/service-plans';
export const PATH_TRADEIN = '/trade-in';
export const PATH_EV_RYI = '/ev-ryi';
export const PATH_3G = '/3g';

// Form field constants
export const FIELD_CHECKBOX = 'FIELD_CHECKBOX';
export const FIELD_CHECKBOX_GROUP = 'FIELD_CHECKBOX_GROUP';
export const FIELD_RADIO = 'FIELD_RADIO';
export const FIELD_SELECT = 'FIELD_SELECT';
export const FIELD_DROPDOWN = 'FIELD_DROPDOWN';
export const FIELD_TEXT = 'FIELD_TEXT';
export const FIELD_TEXTAREA = 'FIELD_TEXTAREA';
export const FIELD_DATE = 'FIELD_DATE';
export const LABEL_OPTIN = <>I would like to be contacted by Audi and Audi Dealers with occasional communications on products, offers, news and events.</>;

//UI mode
export const UI_MYAUDI = 'myaudi';
export const UI_MYAUDI_DEALER = 'myaudidealer';
export const UI_AUDI = 'audi';
export const UI_AUDI_MIN = 'audi-min';
export const UI_AUDI_DEALER = 'audi-dealer';
export const UI_NONE = 'none';

export const STATES_OPTIONS = [
    {label: 'ACT', value: 'ACT'},
    {label: 'NSW', value: 'NSW'},
    {label: 'NT', value: 'NT'},
    {label: 'QLD', value: 'QLD'},
    {label: 'SA', value: 'SA'},
    {label: 'TAS', value: 'TAS'},
    {label: 'VIC', value: 'VIC'},
    {label: 'WA', value: 'WA'},
];

export const PLANNING_TO_BUY_OPTIONS = [
    {
        label: "Within the next 3 months",
        value: "Within next 3 months"
    },
    {
        label: "3 - 6 months",
        value: "3-6 months"
    },
    {
        label: "6 - 12 months",
        value: "6-12 months"
    },
    {
        label: "Not sure",
        value: "Not sure"
    }
];

export const PREF_CONTACT_OPTIONS = [
    {
        label: "Call",
        value: "Phone"
    },
    {
        label: "Email",
        value: "Email"
    },
    {
        label: "Text/SMS",
        value: "Text/SMS"
    }
];

export const MAINTENANCE_FULL = false;
export const MAINTENANCE_SF = false;

// https://help.salesforce.com/s/articleView?id=xcloud.admin_state_country_picklists_standard_countries.htm&type=5
export const COUNTRIES_TOP = [
    {value: "AU", label: "Australia"},
    {value: "NZ", label: "New Zealand"},
];
export const COUNTRIES = [
    {value: "AD", label: "Andorra"},
    {value: "AE", label: "United Arab Emirates"},
    {value: "AF", label: "Afghanistan"},
    {value: "AG", label: "Antigua and Barbuda"},
    {value: "AI", label: "Anguilla"},
    {value: "AL", label: "Albania"},
    {value: "AM", label: "Armenia"},
    {value: "AO", label: "Angola"},
    {value: "AQ", label: "Antarctica"},
    {value: "AR", label: "Argentina"},
    {value: "AT", label: "Austria"},
    {value: "AU", label: "Australia"},
    {value: "AW", label: "Aruba"},
    {value: "AX", label: "Aland Islands"},
    {value: "AZ", label: "Azerbaijan"},
    {value: "BA", label: "Bosnia and Herzegovina"},
    {value: "BB", label: "Barbados"},
    {value: "BD", label: "Bangladesh"},
    {value: "BE", label: "Belgium"},
    {value: "BF", label: "Burkina Faso"},
    {value: "BG", label: "Bulgaria"},
    {value: "BH", label: "Bahrain"},
    {value: "BI", label: "Burundi"},
    {value: "BJ", label: "Benin"},
    {value: "BL", label: "Saint Barthélemy"},
    {value: "BM", label: "Bermuda"},
    {value: "BN", label: "Brunei Darussalam"},
    {value: "BO", label: "Bolivia, Plurinational State of"},
    {value: "BQ", label: "Bonaire, Sint Eustatius, and Saba"},
    {value: "BR", label: "Brazil"},
    {value: "BS", label: "Bahamas"},
    {value: "BT", label: "Bhutan"},
    {value: "BV", label: "Bouvet Island"},
    {value: "BW", label: "Botswana"},
    {value: "BY", label: "Belarus"},
    {value: "BZ", label: "Belize"},
    {value: "CA", label: "Canada"},
    {value: "CC", label: "Cocos (Keeling) Islands"},
    {value: "CD", label: "Congo, the Democratic Republic of the"},
    {value: "CF", label: "Central African Republic"},
    {value: "CG", label: "Congo"},
    {value: "CH", label: "Switzerland"},
    {value: "CI", label: "Cote d’Ivoire"},
    {value: "CK", label: "Cook Islands"},
    {value: "CL", label: "Chile"},
    {value: "CM", label: "Cameroon"},
    {value: "CN", label: "China"},
    {value: "CO", label: "Colombia"},
    {value: "CR", label: "Costa Rica"},
    {value: "CV", label: "Cape Verde"},
    {value: "CW", label: "Curaçao"},
    {value: "CX", label: "Christmas Island"},
    {value: "CY", label: "Cyprus"},
    {value: "CZ", label: "Czechia"},
    {value: "DE", label: "Germany"},
    {value: "DJ", label: "Djibouti"},
    {value: "DK", label: "Denmark"},
    {value: "DM", label: "Dominica"},
    {value: "DO", label: "Dominican Republic"},
    {value: "DZ", label: "Algeria"},
    {value: "EC", label: "Ecuador"},
    {value: "EE", label: "Estonia"},
    {value: "EG", label: "Egypt"},
    {value: "EH", label: "Western Sahara"},
    {value: "ER", label: "Eritrea"},
    {value: "ES", label: "Spain"},
    {value: "ET", label: "Ethiopia"},
    {value: "FI", label: "Finland"},
    {value: "FJ", label: "Fiji"},
    {value: "FK", label: "Falkland Islands (Malvinas)"},
    {value: "FO", label: "Faroe Islands"},
    {value: "FR", label: "France"},
    {value: "GA", label: "Gabon"},
    {value: "GB", label: "United Kingdom"},
    {value: "GD", label: "Grenada"},
    {value: "GE", label: "Georgia"},
    {value: "GF", label: "French Guiana"},
    {value: "GG", label: "Guernsey"},
    {value: "GH", label: "Ghana"},
    {value: "GI", label: "Gibraltar"},
    {value: "GL", label: "Greenland"},
    {value: "GM", label: "Gambia"},
    {value: "GN", label: "Guinea"},
    {value: "GP", label: "Guadeloupe"},
    {value: "GQ", label: "Equatorial Guinea"},
    {value: "GR", label: "Greece"},
    {value: "GS", label: "South Georgia and the South Sandwich Islands"},
    {value: "GT", label: "Guatemala"},
    {value: "GW", label: "Guinea-Bissau"},
    {value: "GY", label: "Guyana"},
    {value: "HM", label: "Heard Island and McDonald Islands"},
    {value: "HN", label: "Honduras"},
    {value: "HR", label: "Croatia"},
    {value: "HT", label: "Haiti"},
    {value: "HU", label: "Hungary"},
    {value: "ID", label: "Indonesia"},
    {value: "IE", label: "Ireland"},
    {value: "IL", label: "Israel"},
    {value: "IM", label: "Isle of Man"},
    {value: "IN", label: "India"},
    {value: "IO", label: "British Indian Ocean Territory"},
    {value: "IQ", label: "Iraq"},
    {value: "IS", label: "Iceland"},
    {value: "IT", label: "Italy"},
    {value: "JE", label: "Jersey"},
    {value: "JM", label: "Jamaica"},
    {value: "JO", label: "Jordan"},
    {value: "JP", label: "Japan"},
    {value: "KE", label: "Kenya"},
    {value: "KG", label: "Kyrgyzstan"},
    {value: "KH", label: "Cambodia"},
    {value: "KI", label: "Kiribati"},
    {value: "KM", label: "Comoros"},
    {value: "KN", label: "Saint Kitts and Nevis"},
    // {value: "KR", label: "Korea, Republic of"},
    {value: "KW", label: "Kuwait"},
    {value: "KY", label: "Cayman Islands"},
    {value: "KZ", label: "Kazakhstan"},
    {value: "LA", label: "Lao People’s Democratic Republic"},
    {value: "LB", label: "Lebanon"},
    {value: "LC", label: "Saint Lucia"},
    {value: "LI", label: "Liechtenstein"},
    {value: "LK", label: "Sri Lanka"},
    {value: "LR", label: "Liberia"},
    {value: "LS", label: "Lesotho"},
    {value: "LT", label: "Lithuania"},
    {value: "LU", label: "Luxembourg"},
    {value: "LV", label: "Latvia"},
    {value: "LY", label: "Libya"},
    {value: "MA", label: "Morocco"},
    {value: "MC", label: "Monaco"},
    {value: "MD", label: "Moldova, Republic of"},
    {value: "ME", label: "Montenegro"},
    {value: "MF", label: "Saint Martin (French part)"},
    {value: "MG", label: "Madagascar"},
    {value: "MK", label: "North Macedonia"},
    {value: "ML", label: "Mali"},
    {value: "MM", label: "Myanmar"},
    {value: "MN", label: "Mongolia"},
    {value: "MO", label: "Macao"},
    {value: "MQ", label: "Martinique"},
    {value: "MR", label: "Mauritania"},
    {value: "MS", label: "Montserrat"},
    {value: "MT", label: "Malta"},
    {value: "MU", label: "Mauritius"},
    {value: "MV", label: "Maldives"},
    {value: "MW", label: "Malawi"},
    {value: "MX", label: "Mexico"},
    {value: "MY", label: "Malaysia"},
    {value: "MZ", label: "Mozambique"},
    {value: "NA", label: "Namibia"},
    {value: "NC", label: "New Caledonia"},
    {value: "NE", label: "Niger"},
    {value: "NF", label: "Norfolk Island"},
    {value: "NG", label: "Nigeria"},
    {value: "NI", label: "Nicaragua"},
    {value: "NL", label: "Netherlands"},
    {value: "NO", label: "Norway"},
    {value: "NP", label: "Nepal"},
    {value: "NR", label: "Nauru"},
    {value: "NU", label: "Niue"},
    {value: "NZ", label: "New Zealand"},
    {value: "OM", label: "Oman"},
    {value: "PA", label: "Panama"},
    {value: "PE", label: "Peru"},
    {value: "PF", label: "French Polynesia"},
    {value: "PG", label: "Papua New Guinea"},
    {value: "PH", label: "Philippines"},
    {value: "PK", label: "Pakistan"},
    {value: "PL", label: "Poland"},
    {value: "PM", label: "Saint Pierre and Miquelon"},
    {value: "PN", label: "Pitcairn"},
    {value: "PS", label: "Palestine"},
    {value: "PT", label: "Portugal"},
    {value: "PY", label: "Paraguay"},
    {value: "QA", label: "Qatar"},
    {value: "RE", label: "Reunion"},
    {value: "RO", label: "Romania"},
    {value: "RS", label: "Serbia"},
    {value: "RU", label: "Russian Federation"},
    {value: "RW", label: "Rwanda"},
    {value: "SA", label: "Saudi Arabia"},
    {value: "SB", label: "Solomon Islands"},
    {value: "SC", label: "Seychelles"},
    {value: "SE", label: "Sweden"},
    {value: "SG", label: "Singapore"},
    {value: "SH", label: "Saint Helena, Ascension and Tristan da Cunha"},
    {value: "SI", label: "Slovenia"},
    {value: "SJ", label: "Svalbard and Jan Mayen"},
    {value: "SK", label: "Slovakia"},
    {value: "SL", label: "Sierra Leone"},
    {value: "SM", label: "San Marino"},
    {value: "SN", label: "Senegal"},
    {value: "SO", label: "Somalia"},
    {value: "SR", label: "Suriname"},
    {value: "SS", label: "South Sudan"},
    {value: "ST", label: "Sao Tome and Principe"},
    {value: "SV", label: "El Salvador"},
    {value: "SX", label: "Sint Maarten (Dutch part)"},
    {value: "SZ", label: "Eswatini"},
    {value: "TC", label: "Turks and Caicos Islands"},
    {value: "TD", label: "Chad"},
    {value: "TF", label: "French Southern Territories"},
    {value: "TG", label: "Togo"},
    {value: "TH", label: "Thailand"},
    {value: "TJ", label: "Tajikistan"},
    {value: "TK", label: "Tokelau"},
    {value: "TL", label: "Timor-Leste"},
    {value: "TM", label: "Turkmenistan"},
    {value: "TN", label: "Tunisia"},
    {value: "TO", label: "Tonga"},
    {value: "TR", label: "Türkiye"},
    {value: "TT", label: "Trinidad and Tobago"},
    {value: "TV", label: "Tuvalu"},
    {value: "TW", label: "Taiwan"},
    {value: "TZ", label: "Tanzania, United Republic of"},
    {value: "UA", label: "Ukraine"},
    {value: "UG", label: "Uganda"},
    {value: "US", label: "United States"},
    {value: "UY", label: "Uruguay"},
    {value: "UZ", label: "Uzbekistan"},
    {value: "VA", label: "Holy See (Vatican City State)"},
    {value: "VC", label: "Saint Vincent and the Grenadines"},
    {value: "VE", label: "Venezuela, Bolivarian Republic of"},
    {value: "VG", label: "Virgin Islands, British"},
    {value: "VN", label: "Vietnam"},
    {value: "VU", label: "Vanuatu"},
    {value: "WF", label: "Wallis and Futuna"},
    {value: "WS", label: "Samoa"},
    {value: "XK", label: "Kosovo"},
    {value: "YE", label: "Yemen"},
    {value: "YT", label: "Mayotte"},
    {value: "ZA", label: "South Africa"},
    {value: "ZM", label: "Zambia"},
    {value: "ZW", label: "Zimbabwe"},
];
